import script from "./DepthElement.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthElement.vue?vue&type=script&setup=true&lang=js"

import "./DepthElement.vue?vue&type=style&index=0&id=76af8550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76af8550"]])

export default __exports__